
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gangwon-veterans/facility/[companyname]",
      function () {
        return require("private-next-pages/gangwon-veterans/facility/[companyname].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gangwon-veterans/facility/[companyname]"])
      });
    }
  